import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Link from "@pathwright/ui/src/components/link/Link"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import Text from "@pathwright/ui/src/components/ui/Text"
import { ConnectStores } from "lib/core/store"
import { urls } from "lib/core/utils"

const tPrefix = "step.permission_lock"

const StepPermissionLock = function (props) {
  const { resourceActionURL, resourceType, is_authenticated, message, t } =
    props

  return (
    <BlankSlate
      icon="lock"
      body={message ? message : t(`${tPrefix}.message`)}
      primaryAction={{
        children: t(`${tPrefix}.take_resource`, { resourceType }),
        to: resourceActionURL
      }}
    >
      {!is_authenticated && (
        <Text.Body>
          {t(`${tPrefix}.have_access`)}{" "}
          <Link
            to={`/auth/sign-in?next=${
              window.location.pathname + window.location.search
            }`}
            className="action-sign-in brand-color"
          >
            {t(`${tPrefix}.sign_in`)}
          </Link>
          .
        </Text.Body>
      )}
    </BlankSlate>
  )
}

StepPermissionLock.displayName = "StepPermissionLock"

const mapStateToProps = function (state, ownProps) {
  const { tca } = ownProps
  const { resource, offering } = state.resourceStore.state
  let resourceType = tca("resource.types.course")
  if (resource.resource_type === 30)
    resourceType = tca("resource.types.collection")
  if (resource.resource_type === 20) resourceType = tca("resource.types.lesson")

  const resourceActionURL = urls.modalRoute(
    `/library/${resource.slug}/register/${offering.id}/`
  )
  const is_authenticated = state.authStore.request.isAuthenticated()
  const props = _.assign(
    {},
    {
      is_authenticated,
      resourceType,
      resourceActionURL
    },
    ownProps
  )
  return props
}

const connectToStores = [
  { store: "auth", watch: ["session"] }, // watch all the state
  { store: "resource", watch: false }
]

export default withTranslate(
  ConnectStores(StepPermissionLock, connectToStores, {}, mapStateToProps)
)
